export const MERGE_ENTITIES = 'entities/MERGE';

export const REMOVE_ENTITIES = 'entities/REMOVE';



// WEBPACK FOOTER //
// ./src/store/entities/action-types.js